export const MODULE_NAME = 'conversion';
export const DATA_SUBMODULE_NAME = 'data';

export const PROMOTION = 'PROMOTION';

export const PLUS_SHIPPING_COST = 'PLUS_SHIPPING_COST';

export const VOUCHER = 'VOUCHER';

export const BINS = 'BINS';

export const WEEKLY = 'WEEKLY';

export const SHELVES_LAYOUT_MAX_ITEMS = 10;

export const MENU_SECTION = {
  WIDGET: 'widget',
  MENU: 'menu',
  SECTION: 'section_details',
  REPEAT_PRODUCT: 'repeat_product',
};

export const PRODUCT_CLICK_LOCATION = {
  PHOTO: 'photo',
  NAME: 'name',
  INFOCARD: 'infocard',
  CARD: 'card',
  PRICE: 'price',
  PLUS: 'plus',
};

export const VERTICAL_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const VERTICAL_GENDER_ARTICLE = {
  MALE: 'El',
  FEMALE: 'La',
};

export const VERTICAL_GENDER_CONTRACTION = {
  MALE: 'Al',
  FEMALE: 'A la',
};

export const VERTICAL_GENDER_CONTRACTION_OF = {
  MALE: 'del',
  FEMALE: 'de la',
};

export const VERTICAL_GENDER_PRONOUM_OTHER = {
  MALE: 'otro',
  FEMALE: 'otra',
};
